import {
  collection,
  query,
  where,
  getDocs,
  doc,
  setDoc,
} from 'firebase/firestore';
import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { v4 } from 'uuid';
import * as Yup from 'yup';
import { useAuth } from '~/hooks/auth';
import { useToast } from '~/hooks/toast';
import IPayment from '~/interfaces/IPayment';
import { DB, Storage, Realtime } from '~/services/firebase';
import getCurrencyFormatted from '~/utils/getCurrencyFormatted';
import getValidationErrors from '~/utils/getValidationErrors';
import { MONTHS } from '~/utils/getEnums';

interface SettingsAppProps {
  openMenu(): void;
}

interface FormData {
  month: string;
  year: string;
}

const SettingsMonthlyPayment: React.FC<SettingsAppProps> = ({ openMenu }) => {
  const { user, company } = useAuth();
  const { addToast } = useToast();
  const [data, setData] = useState({
    year: `${new Date().getFullYear()}`,
    month: `${new Date().getMonth()}`,
  } as FormData);
  const [payments, setPayments] = useState<IPayment[]>([]);
  const [errors, setErrors] = useState({} as any);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function loadPayments() {
      const q = query(
        collection(DB, 'payments'),
        where('user_id', '==', user.uid),
      );

      const querySnapshot = await getDocs(q);

      const items: IPayment[] = [];

      querySnapshot.docs.forEach((item: any) => {
        const tmp = item.data();

        const parseItem = {
          ...tmp,
          uid: item.id,
        } as IPayment;

        items.push(parseItem);
      });

      setPayments(items);
    }

    loadPayments();
  }, [user.uid]);

  const paymentRealtime = useCallback((data: IPayment) => {
    const ref = Realtime.ref(`payments`);
    const newNotificationRef = ref.push();
    newNotificationRef.set(data);
  }, []);

  const handleSubmit = useCallback(
    async event => {
      event.preventDefault();

      try {
        const schema = Yup.object().shape({
          month: Yup.string().required('O campo mês é obrigatório'),
          year: Yup.string().required('O campo ano é obrigatório'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        setLoading(true);

        const inputFileImage = document.getElementById(
          'photo',
        ) as HTMLInputElement;

        let image = '';

        if (
          inputFileImage &&
          inputFileImage.files &&
          inputFileImage.files.length > 0
        ) {
          const file = inputFileImage.files[0];
          const storageRef = Storage.ref(`monthly-payments/${v4()}.png`);
          const resposne = await storageRef.put(file);
          image = await resposne.ref.getDownloadURL();
        } else {
          setErrors({
            image: 'É necessário enviar o comprovante PIX.',
          });

          setLoading(false);

          return;
        }

        const uid = v4();

        let parseData = {
          ...data,
          uid,
          month: parseFloat(data.month),
          year: parseFloat(data.year),
          value: company.plan_value,
          status: null,
          user_id: user.uid,
          user_name: user.name,
          company_id: company.uid,
          company_name: company.fantasy,
        } as any;

        if (image) parseData = { ...parseData, image };

        await setDoc(doc(DB, 'payments', uid), parseData);

        paymentRealtime(parseData);

        setPayments(current => [parseData, ...current]);

        addToast({
          type: 'success',
          description: 'Comprovante enviado com sucesso!',
        });

        setLoading(false);
      } catch (err: any) {
        console.log(err);
        setLoading(false);
        if (err instanceof Yup.ValidationError) {
          const parseErrors = getValidationErrors(err);
          setErrors(parseErrors);
          return;
        }

        addToast({
          type: 'danger',
          description:
            'Infelizmente não foi possível completar a operação. Por favor, Tente novamente.',
        });
      }
    },
    [data, user, addToast, company, paymentRealtime],
  );

  return (
    <div className="nk-block">
      <div className="nk-block-head nk-block-between">
        <div className="nk-block-head-content">
          <h5 className="nk-block-title">Mensalidades</h5>
          <div className="nk-block-des">
            <p>Pague suas mensalidades via PIX e nos envie o comprovante.</p>
          </div>
        </div>
        <div className="nk-block-head-content align-self-start d-lg-none">
          <Link
            to="#menu"
            className="toggle btn btn-icon btn-trigger mt-n1"
            data-target="userAside"
            onClick={openMenu}
          >
            <em className="icon ni ni-menu-alt-r" />
          </Link>
        </div>
      </div>

      <div className="row mb-3">
        <p>
          <b className="me-2">Chave PIX:</b>
          (82) 99938-0548
        </p>
        <p>
          <b className="me-2">Tipo de Chave:</b>
          CELULAR
        </p>
        <p>
          <b className="me-2">Beneficiário:</b>
          THAISA DA CONCEIÇÃO MARTINS DA SILVA
        </p>
      </div>

      <form onSubmit={handleSubmit} className="mb-4">
        <div className="row">
          <div className="col-md-2">
            <div className="form-group mb-3">
              <label className="form-label" htmlFor="default-06">
                Mês
              </label>
              <div className="form-control-wrap ">
                <div className="form-control-select">
                  <select
                    className="form-control"
                    id="default-06"
                    defaultValue={data.month}
                    onChange={event => {
                      setData({
                        ...data,
                        month: event.target.value,
                      });
                    }}
                  >
                    <option value="">Selecione...</option>
                    <option value="0">JANEIRO</option>
                    <option value="1">FEVEREIRO</option>
                    <option value="2">MARÇO</option>
                    <option value="3">ABRIL</option>
                    <option value="4">MAIO</option>
                    <option value="5">JUNHO</option>
                    <option value="6">JULHO</option>
                    <option value="7">AGOSTO</option>
                    <option value="8">SETEMBRO</option>
                    <option value="9">OUTUBRO</option>
                    <option value="10">NOVEMBRO</option>
                    <option value="11">DEZEMBRO</option>
                  </select>
                  {errors.month && (
                    <span className="invalid">{errors.month}</span>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-2">
            <div className="form-group mb-3">
              <label className="form-label">Ano</label>
              <div className="form-control-wrap">
                <input
                  type="number"
                  className="form-control"
                  defaultValue={data.year}
                  onChange={event => {
                    setData({ ...data, year: event.target.value });
                  }}
                />
                {errors.year && <span className="invalid">{errors.year}</span>}
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group mb-3">
              <label className="form-label" style={{ width: '100%' }}>
                Comprovante PIX
              </label>
              <div className="form-control-wrap">
                <input type="file" id="photo" />
              </div>
              {errors.image && <span className="invalid">{errors.image}</span>}
            </div>
          </div>

          <div className="col-12">
            <div className="form-group">
              <button
                type="submit"
                className="btn btn-lg btn-primary"
                disabled={loading}
              >
                {loading && (
                  <div
                    className="spinner-border spinner-border-sm"
                    role="status"
                  />
                )}
                {!loading && 'Enviar'}
              </button>
            </div>
          </div>
        </div>
      </form>

      <div className="nk-tb-list">
        <div className="nk-tb-item nk-tb-head">
          <div className="nk-tb-col">
            <span>Mês</span>
          </div>
          <div className="nk-tb-col">
            <span>Valor</span>
          </div>
          <div className="nk-tb-col">
            <span>Status</span>
          </div>
        </div>

        {payments.map(item => (
          <div className="nk-tb-item" key={item.uid}>
            <div className="nk-tb-col">
              <span className="title">
                {`${MONTHS[item.month]}/${item.year}`}
              </span>
            </div>

            <div className="nk-tb-col">
              <span className="title">{getCurrencyFormatted(item.value)}</span>
            </div>

            <div className="nk-tb-col">
              <div className="asterisk tb-asterisk">
                <span
                  className={`text-${
                    item.status
                      ? 'success'
                      : item.status === null
                      ? 'warning'
                      : 'danger'
                  } fs-12px`}
                >
                  {item.status && <span>Pago</span>}
                  {item.status === null && <span>Pendente</span>}
                  {item.status !== null && !item.status && (
                    <span>Reprovado</span>
                  )}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SettingsMonthlyPayment;
